<template>
  <v-dialog v-model="showNovaParcela" persistent max-width="1100px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Nova(s) Parcela(s)</span>
        <v-spacer></v-spacer>

        <v-btn class="ma-2 white--text" small color="red" @click="() => limparCampos()">
          <v-icon> mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="mt-5">
          <v-col cols="12" sm="3" md="3">
            <v-currency-field
              filled
              v-model="valorMensal"
              autofocus
              label="Valor Parcela"
              :rules="[valorMaiorQueZero]"
              required
            />
          </v-col>

          <v-col cols="12" sm="2" md="2">
            <v-currency-field
              :background-color="error ? 'deep-orange lighten-4' : ''"
              :class="error ? 'animate__animated animate__flash animate__delay-2s' : ''"
              filled
              v-model="desconto_1"
              label="Desconto 1"
              :rules="[campoObrigatorio]"
              required
            />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              filled
              v-model="descontoDia"
              type="number"
              :max="31"
              :min="1"
              label="Dia"
              :rules="[diaObrigatorio]"
              required
            />
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-currency-field
              filled
              v-model="desconto_2"
              label="Desconto 2"
              :rules="[campoObrigatorio]"
              required
            />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              filled
              v-model="descontoDia2"
              type="number"
              :max="31"
              :min="1"
              label="Dia"
              :rules="[diaObrigatorio]"
              required
            />
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-currency-field
              filled
              v-model="desconto_3"
              label="Desconto 3"
              :rules="[campoObrigatorio]"
              required
            />
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <v-text-field
              filled
              v-model="descontoDia3"
              type="number"
              :max="31"
              :min="1"
              label="Dia"
              :rules="[diaObrigatorio]"
              required
            />
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="data"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  @select="
                    data = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                      .toISOString()
                      .substr(0, 10)
                  "
                  v-model="dataFormatada"
                  label="Vencimento"
                  prepend-icon="mdi-calendar"
                  readonly
                  :rules="[campoObrigatorio]"
                  required
                  v-bind="attrs"
                  v-on="on"
                  filled
                ></v-text-field>
              </template>
              <v-date-picker v-model="data" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(data)"> OK </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-select
              v-model="qtdParcelas"
              filled
              :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              label="Qtd Parcelas*"
              :rules="[campoObrigatorio]"
              required
            ></v-select>
          </v-col>
        </v-row>

        <v-row v-if="error">
          <v-col>
            <v-alert type="error" border="bottom" class="animate__animated animate__headShake">
              <template v-slot:prepend="">
                <v-icon x-large> fa fa-warning </v-icon>
              </template>
              <div class="ml-3">Não é permitido o desconto ser maior que o valor da parcela.</div>
            </v-alert>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row class="mt-4 mb-4">
          <v-col cols="8">
            <p class="caption">
              * Verifique as informações geradas abaixo, pois as mesmas contém dados previamente
              preenchidos tais como: Valor da parcela, Desconto, Vencimento e Quantidade de
              parcelas.
            </p>
            <p class="caption">
              ** Ao concluir que as informações estão corretas, clique no botão abaixo: "VINCULAR
              PARCELAS"
            </p>
          </v-col>

          <v-col class="text-right">
            <v-btn
              :disabled="!formularioValido || error"
              color="secondary"
              @click="() => criarParcelas()"
            >
              Visualizar Parcelas
            </v-btn>
          </v-col>
        </v-row>

        <!-- <v-divider vertical></v-divider> -->
        <!-- <v-spacer></v-spacer> -->
        <v-divider></v-divider>
      </v-card-text>
      <v-col>
        <v-row class="mx-0">
          <v-col class="text-left">
            <v-btn
              v-if="parcelas.length > 0"
              :disabled="!parcelas.length > 0"
              class="white--text"
              color="red"
              @click="() => limparParcelas()"
            >
              <v-icon left> mdi-broom </v-icon>
              Limpar listagem
            </v-btn>
          </v-col>
          <v-col class="text-right">
            <v-btn
              v-if="parcelas.length > 0"
              :disabled="!parcelas.length > 0 || !formularioValido"
              class="white--text"
              color="green"
              @click="() => vincularParcelas()"
            >
              Vincular parcelas
            </v-btn>
          </v-col>
        </v-row>

        <v-col></v-col>

        <v-timeline dense clipped v-if="parcelas.length > 0">
          <v-timeline-item
            v-for="(item, index) in parcelas"
            :key="index"
            class="mb-4"
            color="blue"
            icon-color="grey lighten-2"
            small
          >
            <v-row justify="space-between">
              <v-card-text class="py-0">
                <v-list-item-content>
                  <v-list-item-title class="mt-3 caption">
                    <span class="font-weight-bold"> #{{ ++index }}</span> - Valor Mensal:
                    <span class="font-weight-bold"> {{ item.valorMensal | currency }}</span>

                    <span class="font-weight-bold"></span> | Desconto:
                    <span class="font-weight-bold"> {{ item.desconto | currency }}</span>

                    <span class="font-weight-bold"></span> | Valor a ser pago:
                    <span class="font-weight-bold">
                      {{ (item.valorMensal - item.desconto) | currency }}
                    </span>
                  </v-list-item-title>

                  <v-list-item-subtitle class="mt-3 caption">
                    Vencimento: {{ item.vencimento | longDate }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-card-text>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      error: false,
      desconto_1: 0,
      desconto_2: 0,
      desconto_3: 0,
      descontoDia: null,
      descontoDia2: null,
      descontoDia3: null,
      parcelas: [],
      dataFormatada: null,
      data: null,
      menu: false,
      valorMensal: 0,
      qtdParcelas: 1,
      parcelaShow: false,
    };
  },
  props: {
    showNovaParcela: {
      type: Boolean,
    },
    matricula: {
      type: Number,
    },
  },
  computed: {
    formularioValido() {
      return (
        this.temValorPositivo(this.valorMensal) &&
        this.campoEstaPreenchido(this.desconto_1) &&
        this.diaEstaValido(this.descontoDia) &&
        this.campoEstaPreenchido(this.desconto_2) &&
        this.diaEstaValido(this.descontoDia2) &&
        this.campoEstaPreenchido(this.desconto_3) &&
        this.diaEstaValido(this.descontoDia3) &&
        this.campoEstaPreenchido(this.data) &&
        this.campoEstaPreenchido(this.qtdParcelas)
      );
    },
  },
  watch: {
    data(val) {
      this.dataFormatada = this.formatDate(this.data);
    },

    desconto_1(val) {
      this.error =
        val > this.valorMensal ||
        this.desconto_2 > this.valorMensal ||
        this.desconto_3 > this.valorMensal;
    },
    desconto_2(val) {
      this.error =
        val > this.valorMensal ||
        this.desconto_1 > this.valorMensal ||
        this.desconto_3 > this.valorMensal;
    },
    desconto_3(val) {
      this.error =
        val > this.valorMensal ||
        this.desconto_1 > this.valorMensal ||
        this.desconto_2 > this.valorMensal;
    },
  },
  methods: {
    campoEstaPreenchido(valor) {
      return valor !== null && valor !== undefined && valor !== "";
    },

    temValorPositivo(valor) {
      return this.campoEstaPreenchido(valor) && Number(valor) > 0;
    },

    diaEstaValido(valor) {
      const dia = Number(valor);
      return this.campoEstaPreenchido(valor) && Number.isInteger(dia) && dia >= 1 && dia <= 31;
    },

    campoObrigatorio(valor) {
      return this.campoEstaPreenchido(valor) || "Campo obrigatório";
    },

    valorMaiorQueZero(valor) {
      return this.temValorPositivo(valor) || "Informe um valor maior que zero";
    },

    diaObrigatorio(valor) {
      return this.diaEstaValido(valor) || "Informe um dia entre 1 e 31";
    },

    formatDate(data) {
      if (!data) return null;
      const [year, month, day] = data.split("-");
      return `${day}/${month}/${year}`;
    },

    criarParcelas() {
      if (!this.formularioValido || this.error) {
        this.parcelas = [];
        return;
      }

      const numeroDeParcelas = this.qtdParcelas;
      this.parcelas = [];
      for (let index = 0; index < numeroDeParcelas; index++) {
        const d = new Date(this.data);
        d.setMonth(d.getMonth() + index);
        const data_ = d.toISOString().substr(0, 10);

        const anoMes = data_.substring(0, 7);
        const ultimoDiaDoMes = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
        const clampDia = (dia) => Math.min(Number(dia), ultimoDiaDoMes);

        const referencia_1 = this.descontoDia
          ? `${anoMes}-${String(clampDia(this.descontoDia)).padStart(2, "0")}`
          : null;
        const referencia_2 = this.descontoDia2
          ? `${anoMes}-${String(clampDia(this.descontoDia2)).padStart(2, "0")}`
          : null;
        const referencia_3 = this.descontoDia3
          ? `${anoMes}-${String(clampDia(this.descontoDia3)).padStart(2, "0")}`
          : null;

        this.parcelas.push({
          matricula: this.matricula,
          valorMensal: this.valorMensal,
          data: data_.toString(),
          desconto_1: this.desconto_1,
          desconto_2: this.desconto_2,
          desconto_3: this.desconto_3,
          referencia_1,
          referencia_2,
          referencia_3,
          vencimento: this.adicionarMes(this.data, index),
        });
      }
    },

    adicionarMes(data, index) {
      const newDate = new Date(data);
      newDate.setMonth(newDate.getMonth() + index);
      newDate.setDate(newDate.getDate() + 1);
      return newDate;
    },

    limparCampos() {
      this.$emit("status", false);
      this.parcelaShow = false;
      this.desconto_1 = 0;
      this.desconto_2 = 0;
      this.desconto_3 = 0;
      this.descontoDia = null;
      this.descontoDia2 = null;
      this.descontoDia3 = null;
      this.valorMensal = 0;
      this.data = null;
      this.qtdParcelas = 1;
      this.parcelas = [];
    },

    limparParcelas() {
      this.parcelas = [];
    },

    async vincularParcelas() {
      if (!this.formularioValido || this.error) {
        this.$handleError({ message: "Preencha todos os campos obrigatórios antes de salvar." });
        return;
      }

      this.$loaderService.open("Vinculando matrículas");
      try {
        const formulario = [...this.parcelas];
        await this.$services.parcelasService.novaParcela({
          formulario,
        });
        this.$loaderService.close();
        this.limparCampos();
        this.showNovaParcela = false;
        this.$emit("matriculasVinculadas", true);
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
      }
      this.$loaderService.close();
    },
  },
};
</script>
